import colors from '../constants/AvatarsColors';
import defaultAvatar from '../default-avatar.png';

const AvatarInitials = ({ user }) => {
  if (!user) {
    return '';
  }

  let avatarFallback = <img className="avatar-initials" src={defaultAvatar} alt="default" />;
  if (user.firstName && user.lastName) {
    const initials = user.firstName.charAt(0) + user.lastName.charAt(0);
    const colorIndex = (initials.charCodeAt(0) - 65) % 19;
    return (
      <div className="avatar-initials" style={{ backgroundColor: colors[colorIndex] }}>
        {' '}
        {initials}
      </div>
    );
  }

  return avatarFallback;
};

export default AvatarInitials;
